module.exports = __webpack_public_path__ + "static/datatable-headers-dont-20ad572d377c4605dd67467a57451c56.png";